import React from 'react';
import '../../css/home.css';

const Dashboard = () => {
  return (
    <>
      <div className="container-Dashboard">ini adalah component dashboard</div>
    </>
  );
};

export default Dashboard;
